import { dbPost } from '../../apis/commonApi';

class ResVideoFrameController {
  constructor(
    { store, updateStore },
    { pageParam, setPageParam },
    { lblList, setLblList },
    { selectedLbl, setSelectedLbl },
    { searchCondition, setSearchCondition },
    { frameList, setFrameList },
    { selectedFrame, setSelectedFrame },
    { dataList, setDataList },
    { selectedData, setSelectedData },
    modalService,
    validateService,
    navigate
  ) {
    this.store = store;
    this.updateStore = updateStore;
    this.pageParam = pageParam;
    this.setPageParam = setPageParam;
    this.lblList = lblList;
    this.setLblList = setLblList;
    this.selectedLbl = selectedLbl;
    this.setSelectedLbl = setSelectedLbl;
    this.searchCondition = searchCondition;
    this.setSearchCondition = setSearchCondition;
    this.frameList = frameList;
    this.setFrameList = setFrameList;
    this.selectedFrame = selectedFrame;
    this.setSelectedFrame = setSelectedFrame;
    this.dataList = dataList;
    this.setDataList = setDataList;
    this.selectedData = selectedData;
    this.setSelectedData = setSelectedData;
    this.modalService = modalService;
    this.validateService = validateService;
    this.navigate = navigate;
  }

  async fnSearch() {
    const url = '/aia/analysis/video/res/detail.do';

    let response;

    try {
      response = await dbPost(url, this.pageParam);

      if (response instanceof Error) {
        this.modalService.errorAlert('처리중 에러가 발생하였습니다.', () => {});
      } else {
        const uniqueFrames = [
          ...new Map(
            response.dataList.map(item => [
              item.frameNo,
              {
                frameNo: item.frameNo,
                thmb: item.thmb,
              },
            ])
          ).values(),
        ];

        this.setDataList(response?.dataList);
        this.setFrameList(uniqueFrames);
        this.setLblList(response?.lblList);

        this.setSelectedLbl(response?.lblList[0]);
        this.setSelectedFrame(response?.dataList[0].frameNo);

        this.setSelectedData(response?.dataList[0]);
      }
    } catch (e) {
      this.modalService.errorAlert('처리중 에러가 발생하였습니다.', () => {});
    }
  }

  async loadDataChange(model, value) {
    const tempData = { ...this.selectedData };

    if (model === 'freqIntens') {
      if (value === 'FQ_03') {
        this.setSelectedData({
          ...this.selectedData,
          unstableYn: 'Y',
          [model]: value,
        });

        tempData[model] = value;
        tempData.unstableYn = 'N';
      } else {
        this.setSelectedData({
          ...this.selectedData,
          [model]: value,
        });

        tempData[model] = value;
      }
    } else if (model === 'legSittedSupportedYn') {
      if (value === 'Y') {
        this.setSelectedData({
          ...this.selectedData,
          legSittedNotSupportedYn: 'N',
          [model]: value,
        });

        tempData[model] = value;
        tempData.legSittedNotSupportedYn = 'N';
      } else {
        this.setSelectedData({
          ...this.selectedData,
          [model]: value,
        });

        tempData[model] = value;
      }
    } else if (model === 'legSittedNotSupportedYn') {
      if (value === 'Y') {
        this.setSelectedData({
          ...this.selectedData,
          legSittedSupportedYn: 'N',
          [model]: value,
        });

        tempData[model] = value;
        tempData.legSittedSupportedYn = 'N';
      } else {
        this.setSelectedData({
          ...this.selectedData,
          [model]: value,
        });

        tempData[model] = value;
      }
    } else {
      this.setSelectedData({ ...this.selectedData, [model]: value });
      tempData[model] = value;
    }

    const url = '/aia/analysis/video/res/detail/update.do';
    let response;

    try {
      response = await dbPost(url, tempData);

      if (response instanceof Error) {
        this.modalService.errorAlert('처리중 에러가 발생하였습니다.', () => {});
      } else {
        this.setDataList(response?.dataList);
        const temp = response?.dataList;
        const tempSelect1 = temp.filter(
          data => data.frameNo === this.selectedFrame
        );
        const tempSelect2 = tempSelect1.filter(
          data => data.anlsTrprLbl === this.selectedLbl
        )[0];
        this.setSelectedData(tempSelect2);
      }
    } catch (e) {
      this.modalService.errorAlert('처리중 에러가 발생하였습니다.', () => {});
    }
  }

  async lblChange(value) {
    this.setSelectedLbl(value);
  }
  async searchConditionChange(value) {
    this.setSearchCondition(value);
  }
  async selectedFrameChange(value) {
    this.setSelectedFrame(value);
  }
}

export default ResVideoFrameController;
